
import GlobalComponents from './globalComponents';
export default {
  install(Vue) {
    Vue.use(GlobalComponents);
  }
};
